import { createReducer, on } from "@ngrx/store"
import * as NotificationsDataActions from './actions'
import { NotificationsStateInterface } from "../types"
import { Action } from "rxjs/internal/scheduler/Action"

export const  initialState: NotificationsStateInterface = {
  isLoading:            false,
  notifications:        null,
  markedNotifications:  null,
  error:                ""
}

export const NotificationsReducers = createReducer(
  initialState,
  on(NotificationsDataActions.getNotificationsData, (state) => ({...state , isLoading: true})),
  on(NotificationsDataActions.getNotificationsDataSuccess, (state, action ) => ({
    ...state,
    isLoading:        false,
    notifications:    {
      totalNotifications:       action.totalNotifications,
      notifications:  action.notifications
    },
  })),
  on(NotificationsDataActions.getNotificationsDataSuccessAlreadyLoaded, (state, action ) => ({
    ...state,
    isLoading:        false,

  })),
  on(NotificationsDataActions.getNotificationsDataFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error})),
  on(NotificationsDataActions.setNotificationsNewStateToFalse, (state, action) => ({
    ...state,
    notifications: {
      totalNotifications:     state.notifications != null ? state.notifications.totalNotifications : null,
      notifications: state.notifications?.notifications?.map(notification => (
                        action.notificationId.includes(notification.id) ? {
                          ...notification,
                          new: false
                        } : notification
                     )) ?? []
      },
      markedNotifications: {
        totalNotifications: state.markedNotifications?.totalNotifications ?? 0,
        notifications: state.markedNotifications?.notifications?.map(notification => (
          action.notificationId.includes(notification.id) ? {
            ...notification,
            new: false
          } : notification
        )) ?? []
      }
  })),
  on(NotificationsDataActions.updateNotificationsAfterDelete, (state, action) => ({
    ...state,
    notifications: {
      totalNotifications:   state.notifications?.totalNotifications != null ?
                            state.notifications?.totalNotifications- action.notificationIds.length :
                            0,
      notifications:        state.notifications?.notifications?.filter(notification => !action.notificationIds.includes(notification.id)) ?? [],
    },
    // if deleted notification exists in marked notifications, remove it
    markedNotifications:  {
      totalNotifications: (state.markedNotifications?.notifications?.filter(notification =>
        action.notificationIds.includes(notification.id)).length ?? 0) > 0 ? (state.markedNotifications?.totalNotifications ?? 0) - action.notificationIds.length : state.markedNotifications?.totalNotifications ?? 0,
      notifications: state.markedNotifications?.notifications?.filter(notification => !action.notificationIds.includes(notification.id)) ?? []
      },
    }
  )),
  on(NotificationsDataActions.getBookmarkedNotificationsData, (state) => ({...state , isLoading: true})),
  on(NotificationsDataActions.getBookmarkedNotificationsDataSuccess, (state, action ) => ({
    ...state,
    isLoading: false,
    markedNotifications: action

  })),
  on(NotificationsDataActions.setNotificationsMarkedState, (state, action) => ({
    ...state,
    notifications: {
      totalNotifications:     state.notifications != null ? state.notifications.totalNotifications : null,
      notifications: state.notifications?.notifications?.map(notification => (
                        action.notificationIds.includes(notification.id) ? {
                          ...notification,
                          marked: action.state
                        } : notification
                     )) ?? null,
    },
    markedNotifications: {
      totalNotifications: action.state ? (state.markedNotifications?.totalNotifications ?? 0) + 1 : (state.markedNotifications?.totalNotifications ?? 0) -1,
      // if notification is marked add the new notification to the current using concat method and also chnag the
      // marked state of the notification by making a new object with map
      notifications: action.state ?
                     state.markedNotifications?.notifications?.concat(
                     state.notifications?.notifications?.filter(notification => action.notificationIds.includes(notification.id)).map(notification => ({
                      ...notification,
                      marked: action.state
                    })) ?? []
                            ) :
                          state?.markedNotifications?.notifications?.filter(notification => !action.notificationIds.includes(notification.id)) ?? []
    }
  })),
  on(NotificationsDataActions.resetNotificationsData, () => ({
    ...initialState
  })),
)
